import * as React from 'react'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc/es5'
import { Loading3QuartersOutlined } from '@ant-design/icons'
import { AppState } from '@halo/stores/app.state'
import { isDef } from '@pushly/aqe/lib/utils/is-def'
import { classnames } from '@halo/_utils/classnames'
import './loading-screen.scss'

interface IProps {
    loading?: boolean
}

@observer
export class LoadingScreen extends React.PureComponent<IProps, {}> {
    private appState: AppState

    public constructor(props: IProps) {
        super(props)

        this.appState = Container.get(AppState)
    }

    public render() {
        const loading = isDef(this.props.loading)
            ? this.props.loading
            : this.appState.moduleLoading || this.appState.appIsLoading

        return (
            <div
                className={classnames('loading-screen', {
                    ['active']: loading,
                })}
            >
                <div className={classnames('loading-screen-content')}>
                    <Loading3QuartersOutlined spin={true} />
                </div>
            </div>
        )
    }
}
